import { Api } from '@/services/Api'

export default {
  getFireAlarmData (plantId) {
    return Api().get(`/api/v2/fire-alarm/live-data/${plantId}`)
  },
  getBlockList(plantId) {
    return Api().get(`/api/v1.0/block_list/${plantId}/fire alarm`)
  },
}